import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Button from '@components/common/Button';
import './HealthProviderOverview.css';
import { buttonNames } from '@constants/appConstants';
import { useDispatch, useSelector } from 'react-redux';
import { setApprovalPageType } from '@store/actions/approvalActions';
import { STATUS, approvalConstantData, approvalsRoleCode, checkUserRole, errorSuccessMessage, roleType } from '@constants/approvalConstants';
import PreviousDetailsView from './PreviousDetailsView';
import CurrentDetailsView from './CurrentDetailsView';
import { RootState } from '@store/reducers';
import { PagePermission } from '@services/usePermission';
import ApprovalModal from '@pages/Approval/HealthFacility/approvalModal';
import { approvalStatusUpdate } from '@services/approvalApiServices';
import { toast } from 'react-toastify';
import { decodeWithKeyAndShift } from '@utils/base64Utils';
import dayjs from 'dayjs';

interface propType {
  healthProviderData: any;
}

const HealthProviderOverview = (props: propType) => {
  const { healthProviderData } = props;
  const [selectedView, setSelectedView] = useState('Current Details');
  const dispatch = useDispatch();
  const approvalLayout = useSelector((state: RootState) => state.approvalWorkFlow);
  const resubmitEnable = PagePermission(approvalsRoleCode.module_code, approvalsRoleCode.pageCode.Approvals_Resubmit)
  const editApproveEnable = PagePermission(approvalsRoleCode.module_code, approvalsRoleCode.pageCode.Approvals_EDPg)
  const rejectEnable = PagePermission(approvalsRoleCode.module_code, approvalsRoleCode.pageCode.Approvals_Reject)
  const encodedUserRoles = localStorage.getItem('userRoleDetails');
  const userRolesDetails = encodedUserRoles ? JSON.parse(decodeWithKeyAndShift(encodedUserRoles)).split(', ') : [];
  const roleData = checkUserRole(userRolesDetails)
  const [showApprovalModal, setShowApprovalModal] = useState<boolean>(false);
  const navigate = useNavigate();


  const handleReject = async () => {
    let statusChangedId = ''
    if (approvalLayout.requestData.requestFor == 'received') {
      const rejectedData = approvalLayout.approvalStatus.length > 0 ? approvalLayout.approvalStatus.filter((ele: any) => ele.code == STATUS.REJECTED) : [];
      statusChangedId = rejectedData.length > 0 ? rejectedData[0].id : ''
    }
    const reducerData = approvalLayout.requestData;
    const comments = approvalLayout.comments;
    const res = await approvalStatusUpdate(reducerData, comments, null, statusChangedId, false,healthProviderData[0]?.current_data?.user_details?.user_name,dayjs(healthProviderData[0]?.effective_from_date).format('YYYY-MM-DD'), 'REJECTED', healthProviderData[0]?.current_data?.user_details?.[0]?.mobile_number); 
    if (res) { 
        toast.success(errorSuccessMessage.rejectSuccess, {
          position: 'top-center',
        });

      navigate(`/approvals-flow`);
    }
  }

  return (
    <>
      <div className="health-facility-overview-container">
        <div className="health-facility-tabs-container">
          <div
            onClick={() => setSelectedView('Previous Details')}
            className={`health-facility-tab ${selectedView === 'Previous Details' ? 'active' : 'inactive'}`}
          >
            Previous Details
          </div>
          <div
            onClick={() => setSelectedView('Current Details')}
            className={`health-facility-tab ${selectedView === 'Current Details' ? 'active' : 'inactive'}`}
          >
            Current Details
          </div>
        </div>

        {selectedView === 'Current Details' && (
          <div className="health-facility-actions">
            {(approvalLayout.requestData.requestFor == approvalConstantData.requestFor.sent && resubmitEnable) && <Button
              onClick={() => { dispatch(setApprovalPageType(approvalConstantData.pageType.edit)) }}
              disabled={(approvalLayout.requestData.requestStatus === STATUS.PENDING || approvalLayout.requestData.requestStatus === STATUS.APPROVED) ||  approvalLayout.requestData.requestResubmited}
              id="edit-details"
              buttonName={buttonNames.reSubmit}
              colorType={'primary'}
              icon={''}
              iconPosition={''}
            />}
            {approvalLayout.requestData.requestFor == approvalConstantData.requestFor.received && <>
              {rejectEnable && <Button
                onClick={() => { setShowApprovalModal(true); }}
                disabled={roleData == roleType.only_administrator || approvalLayout.requestData.requestStatus === STATUS.REJECTED || approvalLayout.requestData.requestStatus === STATUS.APPROVED || approvalLayout.requestData.requestStatus === STATUS.NO_ACTION}
                id="cancel"
                buttonName={buttonNames.reject}
                colorType={'save'}
                icon={''}
                iconPosition={''}
              />}
              {editApproveEnable && <Button
                onClick={() => { dispatch(setApprovalPageType(approvalConstantData.pageType.edit)) }}
                disabled={roleData == roleType.only_administrator || approvalLayout.requestData.requestStatus === STATUS.REJECTED || approvalLayout.requestData.requestStatus === STATUS.APPROVED || approvalLayout.requestData.requestStatus === STATUS.NO_ACTION}
                id="edit-details"
                buttonName={buttonNames.editApprove}
                colorType={'primary'}
                icon={''}
                iconPosition={''}
              />}
            </>}
          </div>
        )}
      </div>
      <hr />
      <div className="selected-content">
        {selectedView === 'Previous Details' && (
          <>{(healthProviderData[0]?.previous_data[0]?.facility && healthProviderData[0]?.previous_data[0]?.facility.length > 0) ? <PreviousDetailsView facilityDetails={healthProviderData[0]?.previous_data[0]?.facility} /> : 'No Previous Details'}</>
        )}
        {selectedView === 'Current Details' && (
          <>{(healthProviderData[0]?.current_data ? <CurrentDetailsView healthProviderCurrentDetails={healthProviderData[0]}/> : 'No Current Details')}</>
        )}
      </div>
      {showApprovalModal && <ApprovalModal showModal={showApprovalModal} handleModalClose={() => setShowApprovalModal(false)} handleSubmit={handleReject} headerText='Reason for Rejection' isCommentsRequired={true} />}
    </>
  );
};

export default HealthProviderOverview;
